module.exports = __webpack_public_path__ + "img/step3.8b2ece40.png";